import { render, staticRenderFns } from "./Checkout.handler.vue?vue&type=template&id=a8c072ec&"
import script from "./Checkout.handler.vue?vue&type=script&lang=ts&"
export * from "./Checkout.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports